import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-upload-excel-dialog',
  templateUrl: './upload-excel-dialog.component.html',
  styleUrls: ['./upload-excel-dialog.component.css']
})
export class UploadExcelDialogComponent implements OnInit {
  message: any;
  dataJson: any;

  constructor(
    private dialogRef: MatDialogRef<UploadExcelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private toast: ToastrService,
  ) {
    //this.message = data;
  }

  ngOnInit(){}

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(this.dataJson);
  }

  onFileChange(event: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary', cellDates: true, cellNF: false, cellText: false });

      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0].trim();
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* Save data */
    const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
      this.dataJson = data;
    };
  }

}
